import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, OnDestroy, OnInit, Output, ViewEncapsulation, signal } from '@angular/core'
import { Router } from '@angular/router'
import { ValidatorService } from '../../../common/utilities/validator.service'
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { languageContent } from '../../../common/json/sign-up-content'
import { personalDetailsContent } from '../../../common/json/personal-details-content'
import { UserInputService } from 'src/app/common/api/services/user-input.service'
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core'
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter'
import moment from 'moment'
import { DatePipe, ViewportScroller, NgClass, AsyncPipe } from '@angular/common'
import { ProgressiveProfileService } from 'src/app/common/api/services/progressive-profile.service'
import { WIRService } from 'src/app/common/api/services/wir.service'
import { GtmImplementation } from 'src/app/common/api/services/gtmImplementation'
import { ReplaySubject } from 'rxjs'
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker, MatDatepickerActions, MatDatepickerCancel, MatDatepickerApply } from '@angular/material/datepicker';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatSelectSearchComponent } from 'ngx-mat-select-search';

export const MY_DATE_FORMAT2 = {
  parse: { dateInput: 'DD/MM/YYYY' },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
}

@Component({
    selector: 'app-personal-details',
    templateUrl: './personal-details.component.html',
    styleUrls: ['./personal-details.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT2 },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] }
    ],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, NgClass, MatSelect, MatOption, MatInput, MatDatepickerInput, MatSuffix, MatDatepickerToggle, MatDatepicker, MatDatepickerActions, MatDatepickerCancel, MatDatepickerApply, MatChipListbox, MatChipOption, MatSelectSearchComponent, AsyncPipe]
})
export class PersonalDetailsComponent implements OnInit, OnDestroy {
  showLoader = signal(false)
  selectedLanguage: any
  questions: any
  personalDetailsForm: any
  minimumLength: any
  maximumLength: any
  selectedDialCode: any
  mobileNumberCount: any
  phoneNumberInvalidError: any
  selectMultiple: any
  mobileNumber: any
  submitted: any
  country: any
  invalidDate: boolean = false
  futureDate: boolean = false
  phoneNumberFromCP: any
  primary_email: any
  cpCallDone: any
  userInputServiceGender: any
  interestedIdpServiceGTM: any
  interestedIdpService: any
  allData: { [key: string]: any } = {}
  searchFilterCtrl: FormControl = new FormControl()
  filteredOptions: ReplaySubject<any[]> = new ReplaySubject<any[]>(1)
  allNationalityOptions: any[] = []
  yesterdayDate = moment().subtract(1, 'day')
  defaultLanguage = 'EN'
  optionalText: any
  cancelText: any
  applyText: any
  invalidDOBText: any
  futureDOBText: any
  nextText: any
  showLearnMorePopup: boolean = false
  genderMaritalNoteText: any
  learnMoreText: any
  learnMoreTitleText: any
  learnMoreIntroText: any
  learnMorePoint1TitleText: any
  learnMorePoint1DescText: any
  learnMorePoint2TitleText: any
  learnMorePoint2DescText: any
  learnMorePoint3TitleText: any
  learnMorePoint3DescText: any
  okText: any

  disableFutureDates = (date: moment.Moment | null): boolean => {
    if (!date) return false
    return date.isSameOrBefore(this.yesterdayDate, 'day')
  }

  @Output() nextClicked = new EventEmitter<void>()
  @Output() existingUserChecked = new EventEmitter<boolean>()

  constructor (
    public route: Router,
    public formBuilder: FormBuilder,
    public validatorService: ValidatorService,
    public userInputService: UserInputService,
    public viewPortScroller: ViewportScroller,
    private WIRService: WIRService,
    private cdr: ChangeDetectorRef,
    private el: ElementRef,
    public datePipe: DatePipe,
    public progressiveProfileService: ProgressiveProfileService,
    public gtmImplementation: GtmImplementation
  ) {
    this.personalDetailsForm = this.formBuilder.group({})
  }

  private getOfficeDetails (): any {
    const sfResponse: any = localStorage.getItem('sfResponse')
    return JSON.parse(sfResponse)
  }

  showScrollBtn: boolean = false
  isScrolling: boolean = false
  private scrollTimer: any = null
 
  @HostListener('window:scroll')
  onWindowScroll (): void {
    this.showScrollBtn = window.scrollY > 50
    this.isScrolling = true
    this.cdr.detectChanges()
    clearTimeout(this.scrollTimer)
    this.scrollTimer = setTimeout(() => {
      this.isScrolling = false
      this.cdr.detectChanges()
    }, 300)
  }

  ngOnInit (): void {
    this.showLoader.set(true)
    this.viewPortScroller.scrollToPosition([0, 0])
    this.gtmImplementation.pageView('personal_details', 'signed_in_user', 'user_registration')
    this.selectedLanguage = localStorage.getItem('languageSelected') ? localStorage.getItem('languageSelected') : 'EN'
    this.country = this.getOfficeDetails()?.wir_country_code
    this.getLanguageContent(this.selectedLanguage)
    if (this.selectedLanguage === 'EN') {
      this.selectMultiple = languageContent[this.selectedLanguage]?.selectMultiple
      this.mobileNumber = languageContent[this.selectedLanguage]?.mobileNumber
    } else {
      this.selectMultiple = languageContent[this.country + '_' + this.selectedLanguage]?.selectMultiple
      this.mobileNumber = languageContent[this.country + '_' + this.selectedLanguage]?.mobileNumber
    }
    this.filteredOptions.next(this.questions ?? [])
    this.searchFilterCtrl.valueChanges.subscribe(() => { this.filterOptions() })
    this.getEmail()
  }

  getLanguageContent (language: any): any {
    const key = language === 'EN' ? language : this.country + '_' + language
    this.optionalText = personalDetailsContent[key]?.optional
    this.cancelText = personalDetailsContent[key]?.cancel
    this.applyText = personalDetailsContent[key]?.apply
    this.invalidDOBText = personalDetailsContent[key]?.invalidDOB
    this.futureDOBText = personalDetailsContent[key]?.futureDOB
    this.nextText = personalDetailsContent[key]?.next
    this.genderMaritalNoteText = personalDetailsContent[key]?.genderMaritalNote
    this.learnMoreText = personalDetailsContent[key]?.learnMore
    this.learnMoreTitleText = personalDetailsContent[key]?.learnMoreTitle
    this.learnMoreIntroText = personalDetailsContent[key]?.learnMoreIntro
    this.learnMorePoint1TitleText = personalDetailsContent[key]?.learnMorePoint1Title
    this.learnMorePoint1DescText = personalDetailsContent[key]?.learnMorePoint1Desc
    this.learnMorePoint2TitleText = personalDetailsContent[key]?.learnMorePoint2Title
    this.learnMorePoint2DescText = personalDetailsContent[key]?.learnMorePoint2Desc
    this.learnMorePoint3TitleText = personalDetailsContent[key]?.learnMorePoint3Title
    this.learnMorePoint3DescText = personalDetailsContent[key]?.learnMorePoint3Desc
    this.okText = personalDetailsContent[key]?.ok
  }

  getEmail (): void {
    this.primary_email = this.userInputService.getValue('primary_email')?.option_value
    if (this.primary_email === undefined) {
      this.primary_email = localStorage.getItem('userEmail')
      if (this.primary_email) {
        this.userInputService.setValue('primary_email', this.primary_email)
      }
    }
    this.cpCall()
  }

  filterOptions (): any {
    let search = this.searchFilterCtrl.value
    if (!search) {
      this.filteredOptions.next(this.allNationalityOptions.slice())
      return
    }
    search = search.toLowerCase()
    this.filteredOptions.next(
      this.allNationalityOptions.filter((opt: any) => opt.option_label.toLowerCase().includes(search))
    )
  }

  cpCall (): any {
    this.cpCallDone = this.userInputService.getValue('personal_cp_call_done')
    if (this.cpCallDone !== 'true') {
      this.cpStudentCall()
    } else {
      this.getProgressiveProfileQstns()
    }
  }

  cpStudentCall (): any {
    this.userInputService.setValue('personal_cp_call_done', 'true')
    this.WIRService.isUserAlreadyExist(this.primary_email, this.selectedLanguage).subscribe({
      next: (user: any) => {
        if (user.student_uuid) {
          this.userInputService.setValue('customerUuid', { option_value: user.student_uuid, option_label: user.student_uuid })
        }
        if (user.student_already_exists === true) {
          localStorage.setItem('isExistingUser', 'true')
          this.existingUserChecked.emit(true)
          this.prePopulateFromCP(user)
        } else {
          localStorage.setItem('isExistingUser', 'false')
          this.existingUserChecked.emit(false)
        }
        this.getProgressiveProfileQstns()
      },
      error: (err: any) => {
        this.showLoader.set(false)
        if (!localStorage.getItem('sfResponse')) {
          console.warn('[PersonalDetails] Session expired - redirecting to landing page')
          this.route?.navigateByUrl('/')
        } else {
          console.log('Error in isUserAlreadyExist:', err)
          this.route?.navigateByUrl('/error')
        }
      }
    })
  }

  getProgressiveProfileQstns (): any {
    this.questions = this.progressiveProfileService.serviceQuestions?.items[0]?.fields?.questions
    if (this.questions === undefined) {
      this.showLoader.set(true)
      this.progressiveProfileService.getPPqstns().subscribe(
        (res: any) => {
          this.questions = res.items[0].fields.questions
          this.generateFormControl(this.questions)
          this.autopopulateDataToService()
        },
        (error: any) => {
          console.log(error)
          this.showLoader.set(false)
          this.route?.navigateByUrl('/error')
        }
      )
    } else {
      this.generateFormControl(this.questions)
      this.autopopulateDataToService()
    }
  }

  prePopulateFromCP (user: any): any {
    this.userInputService.setValue('cp_response', user.cp_response)
    this.userInputService.setValue('first_name', user.cp_response.studentBaseInfo.firstName)
    this.userInputService.setValue('last_name', user.cp_response.studentBaseInfo.lastName)
    const numberWithDialCode = user.cp_response.studentBaseInfo.primaryMobileNumber
    if (numberWithDialCode !== null) {
      const numberWithoutDialCode = numberWithDialCode.split(' ')
      this.phoneNumberFromCP = numberWithoutDialCode[numberWithoutDialCode.length - 1]
      this.userInputService.setValue('primary_mobile_number', this.phoneNumberFromCP)
    }
    this.userInputService.setValue('primary_email', user.cp_response.studentBaseInfo.primaryEmail)
    const dateOfBirth = user.cp_response.studentBaseInfo.dateOfBirth
    if (dateOfBirth !== null) {
      const dateOfBirthFormatted = moment(dateOfBirth, 'YYYY-MM-DD').format('DD/MM/YYYY')
      this.userInputService.setValue('date_of_birth', dateOfBirthFormatted)
      const dobAPI = moment(dateOfBirthFormatted, 'DD/MM/YYYY').format('YYYY-MM-DD') + 'T00:00:00'
      this.onInputChange('date_of_birth_API', dobAPI)
    }
    this.userInputService.setValue('maritalStatus', { option_label: user.cp_response.studentAdditionalInfo.maritalStatus, option_desc: user.cp_response.studentAdditionalInfo.maritalStatus })
    this.userInputService.setValue('nationalityCode', { option_label: user.cp_response.studentAdditionalInfo.nationalityCode, option_desc: user.cp_response.studentAdditionalInfo.nationalityCode })
    const gender = user.cp_response.studentBaseInfo.gender
    if (gender === 'Nonbinary') {
      this.userInputServiceGender = 'Non-Binary'
    } else if (gender === 'Gender not known') {
      // do nothing
    } else if (gender === 'Gender not specified') {
      this.userInputServiceGender = 'Prefer not to say'
    } else {
      this.userInputServiceGender = gender
    }
    this.userInputService.setValue('gender', { option_label: this.userInputServiceGender, option_desc: this.userInputServiceGender })
    this.userInputService.setValue('primaryFinancialSource', { option_label: user.cp_response.studentAdditionalInfo.primaryFinancialSource, option_desc: user.cp_response.studentAdditionalInfo.primaryFinancialSource })
    this.userInputService.setValue('howDidYouHear', { option_label: user.cp_response.studentAdditionalInfo.howDidYouHear, option_desc: user.cp_response.studentAdditionalInfo.howDidYouHear })
    // Prepopulate study plan fields for existing users
    if (user.cp_response.studentAdditionalInfo?.preferredCountryCode) {
      this.userInputService.setValue('preferredCountryCode', { option_label: user.cp_response.studentAdditionalInfo.preferredCountryCode, option_desc: user.cp_response.studentAdditionalInfo.preferredCountryCode, option_value: user.cp_response.studentAdditionalInfo.preferredCountryCode })
    }
    if (user.cp_response.studyPlanDetail?.preferredStudyLevel) {
      this.userInputService.setValue('preferredStudyLevel', { option_value: user.cp_response.studyPlanDetail.preferredStudyLevel, option_label: user.cp_response.studyPlanDetail.preferredStudyLevel, option_desc: user.cp_response.studyPlanDetail.preferredStudyLevel })
    }
    if (user.cp_response.studyPlanDetail?.studyPlanDate) {
      const studyPlanOption = this.mapStudyPlanDateToOption(user.cp_response.studyPlanDetail.studyPlanDate)
      if (studyPlanOption) {
        this.userInputService.setValue('studyPlanTimeline', studyPlanOption)
      }
    }
    if (user.cp_response.studentAdditionalInfo.englishIsFirstLanguage) {
      this.userInputService.setValue('englishIsFirstLanguage', { option_value: user.cp_response.studentAdditionalInfo.englishIsFirstLanguage, option_label: user.cp_response.studentAdditionalInfo.englishIsFirstLanguage })
    }
    if (user.cp_response.studyRelatedIdpInfo?.termsAndConditionsAcceptance?.toLowerCase() === 'yes') {
      this.userInputService.setValue('termsAndConditionsAcceptance', { option_value: true, option_label: true })
    }
    if (user.cp_response.studentAdditionalInfo?.contactMeBy) {
      this.userInputService.setValue('contactMeBy', { option_value: true, option_label: true })
    }
    if (user.cp_response.marketingAcceptance?.acceptEmails?.toLowerCase() === 'yes' || user.cp_response.marketingAcceptance?.acceptPhoneCalls?.toLowerCase() === 'yes') {
      this.userInputService.setValue('marketing_acceptance_flag', true)
    }
    if (user.cp_response.qualification_details?.educationHistory?.educationId) {
      this.userInputService.setValue('educationId', { option_value: user.cp_response.qualification_details.educationHistory.educationId, option_label: user.cp_response.qualification_details.educationHistory.educationId })
      this.userInputService.setValue('cp_original_studyCountryCode', user.cp_response.qualification_details.educationHistory.studyCountryCode || null)
      this.userInputService.setValue('cp_original_qualificationTypeId', user.cp_response.qualification_details.educationHistory.qualificationTypeId || null)
    }
    if (user.cp_response.qualification_details?.englishTest?.testId) {
      this.userInputService.setValue('englishTestId', { option_value: user.cp_response.qualification_details.englishTest.testId, option_label: user.cp_response.qualification_details.englishTest.testId })
      this.userInputService.setValue('cp_original_englishTestTypeId', user.cp_response.qualification_details.englishTest.testTypeId || null)
    }
    if (user.cp_response.qualification_details?.admissionTest?.testId) {
      this.userInputService.setValue('admissionTestId', { option_value: user.cp_response.qualification_details.admissionTest.testId, option_label: user.cp_response.qualification_details.admissionTest.testId })
      this.userInputService.setValue('cp_original_admissionTestTypeId', user.cp_response.qualification_details.admissionTest.testTypeId || null)
    }
  }

  private mapStudyPlanDateToOption (studyPlanDate: string): any {
    // studyPlanDate format: "Jun-2027", "Mar-2026", etc.
    const now = new Date()
    const parts = studyPlanDate.split('-')
    if (parts.length !== 2) return null

    const monthStr = parts[0]
    const year = parseInt(parts[1], 10)
    if (isNaN(year)) return null

    const monthMap: { [key: string]: number } = {
      Jan: 0,
      Feb: 1,
      Mar: 2,
      Apr: 3,
      May: 4,
      Jun: 5,
      Jul: 6,
      Aug: 7,
      Sep: 8,
      Oct: 9,
      Nov: 10,
      Dec: 11
    }
    const month = monthMap[monthStr]
    if (month === undefined) return null

    const targetDate = new Date(year, month, 1)
    const diffMonths = (targetDate.getFullYear() - now.getFullYear()) * 12 + (targetDate.getMonth() - now.getMonth())

    // Map to closest option: 1 (Now), 3, 6, 12, 15 (>12), 18 (Not sure)
    let optionValue: string
    if (diffMonths <= 1) {
      optionValue = '1'
    } else if (diffMonths <= 3) {
      optionValue = '3'
    } else if (diffMonths <= 6) {
      optionValue = '6'
    } else if (diffMonths <= 12) {
      optionValue = '12'
    } else if (diffMonths <= 17) {
      optionValue = '15'
    } else {
      optionValue = '18'
    }

    // Find matching option from PP questions
    const question = this.questions?.find((q: any) => q.mappingField === 'studyPlanTimeline')
    if (question?.options?.length) {
      const matched = question.options.find((o: any) => o.option_value === optionValue)
      if (matched) return matched
    }

    return { option_value: optionValue, option_label: optionValue }
  }

  private readonly CHIP_FIELDS: string[] = ['gender', 'maritalStatus', 'passport', 'preferredCountryCode', 'preferredStudyLevel']

  autopopulateDataToService (): any {
    const storedData = this.userInputService.getAllValues()
    for (const key in storedData) {
      const value = storedData[key]
      if (!(key === 'first_name' || key === 'last_name' ||
        key === 'primary_mobile_number' || key === 'primary_email' ||
        key === 'dialCode' || key === 'marketing_acceptance_flag' ||
        key === 'date_of_birth')) {
        if (this.CHIP_FIELDS.includes(key)) {
          const question = this.questions
            ?.find((q: { mappingField: string }) => q.mappingField === key)
          if (question?.options?.length) {
            const matchedOpt = question.options.find((opt: any) => opt.option_value === value?.option_value || opt.option_label === value?.option_label || (value?.option_desc && opt.option_desc === value?.option_desc))
            if (matchedOpt) {
              this.userInputService.setValue(key, matchedOpt)
              continue
            }
          }
          this.userInputService.setValue(key, value)
          continue
        }
        if (Array.isArray(value)) {
          const question = this.questions
            ?.find((q: { mappingField: string }) => q.mappingField === key)
          if (question?.options?.length) {
            const matchedArray = value
              .map((v: any) => question.options.find((opt: any) => opt.option_label === v.option_label || opt.option_value === v.option_value || (v.option_desc && opt.option_desc === v.option_desc)))
              .filter(Boolean)
            if (matchedArray.length > 0) {
              this.userInputService.setValue(key, matchedArray)
            }
          }
          continue
        }
        const question = this.questions
          ?.find((q: { mappingField: string }) => q.mappingField === key)
        const matchingOption = question?.options
          ?.find((opt: { option_label: any, option_value: any, option_desc?: any }) => opt.option_label === value?.option_label || opt.option_value === value?.option_value || (value?.option_desc && opt.option_desc === value?.option_desc))
        this.onInputChange(key, matchingOption ?? value)
      }
    }
  }

  generateFormControl (ppQuestions: any): any {
    const formControl: any = {}
    if (ppQuestions) {
      ppQuestions.forEach((element: any) => {
        // Only add form controls for personal details page fields
        if (this.isPersonalDetailsField(element.mappingField)) {
          this.addPersonalFormControl(element, formControl)
        }
      })
    }
    this.personalDetailsForm = new FormGroup(formControl)
    this.patchStoredValues()
    this.showLoader.set(false)
  }

  private isPersonalDetailsField (mappingField: string): boolean {
    const personalDetailsFields = [
      'title',
      'first_name',
      'last_name',
      'dialCode',
      'primary_mobile_number',
      'date_of_birth',
      'gender',
      'maritalStatus',
      'nationalityCode',
      'passport',
      'preferredCountryCode',
      'interestedIDPSerivce',
      'preferredStudyLevel',
      'studyPlanTimeline',
      'modeOfCounselling',
      'primaryFinancialSource',
      'howDidYouHear'
    ]
    return personalDetailsFields.includes(mappingField)
  }

  private getFieldValidators (element: any): any[] {
    return element.mandatory ? [Validators.required] : []
  }

  private addPersonalFormControl (element: any, formControl: any): void {
    if (element.displayFormat.value === 'SELECT_BOX') {
      this.addPersonalSelectBox(element, formControl)
    } else if (element.displayFormat.value === 'TEXT_BOX' && (element.mappingField === 'first_name' || element.mappingField === 'last_name' || element.mappingField === 'primary_mobile_number')) {
      formControl[element.mappingField] = new FormControl('', this.getFieldValidators(element))
    } else if (element.displayFormat.value === 'DATE_PICKER') {
      formControl[element.mappingField] = new FormControl('', this.getFieldValidators(element))
    }
    if (element.mappingField === 'nationalityCode') {
      this.allNationalityOptions = element.options ?? []
      this.filteredOptions.next(this.allNationalityOptions.slice())
    }
  }

  private addPersonalSelectBox (element: any, formControl: any): void {
    if (element.mappingField === 'dialCode') {
      formControl[element.mappingField] = new FormControl(element.defaultValue, this.getFieldValidators(element))
      this.minimumLength = element.minLength
      this.maximumLength = element.maxLength
      this.mobileNumberCount = element.minLength === element.maxLength
        ? element.minLength
        : element.minLength + ' - ' + element.maxLength
    } else {
      formControl[element.mappingField] = new FormControl('', this.getFieldValidators(element))
    }
  }

  private patchStoredValues (): void {
    const storedData = this.userInputService.getAllValues()
    const patchValues: { [key: string]: any } = {}
    for (const key in storedData) {
      const value = storedData[key]
      if (key === 'date_of_birth') {
        patchValues[key] = moment(value?.option_label, 'DD/MM/YYYY')
      } else if (Array.isArray(value)) {
        const resolved = this.resolveArrayPatchValue(key, value, storedData)
        if (resolved === null) return
        patchValues[key] = resolved
      } else {
        const question = this.questions?.find((q: any) => q.mappingField === key)
        const matchedOpt = question?.options?.find((opt: any) => opt.option_value === value?.option_value || opt.option_label === value?.option_label || (value?.option_desc && opt.option_desc === value?.option_desc))
        patchValues[key] = matchedOpt?.option_label || value?.option_label
      }
    }
    this.personalDetailsForm.patchValue(patchValues)
  }

  private resolveArrayPatchValue (key: string, value: any[], storedData: any): any {
    const question = this.questions?.find((q: any) => q.mappingField === key)
    if (!question?.options?.length) {
      setTimeout(() => this.patchRetryValues(storedData), 100)
      return null
    }
    return value
      .map((v: any) => question.options.find((opt: any) => opt.option_value === v.option_value || opt.option_label === v.option_label || (v.option_desc && opt.option_desc === v.option_desc)))
      .filter(Boolean)
  }

  private patchRetryValues (storedData: any): void {
    const patchValuesRetry: any = {}
    for (const retryKey in storedData) {
      const retryValue = storedData[retryKey]
      if (retryKey === 'date_of_birth') {
        patchValuesRetry[retryKey] = moment(retryValue?.option_label, 'DD/MM/YYYY')
      } else if (Array.isArray(retryValue)) {
        const retryQuestion = this.questions?.find((q: any) => q.mappingField === retryKey)
        if (retryQuestion?.options?.length) {
          patchValuesRetry[retryKey] = retryValue
            .map((v: any) => retryQuestion.options.find((opt: any) => opt.option_value === v.option_value || opt.option_label === v.option_label))
            .filter(Boolean)
        }
      } else {
        const retryQuestion = this.questions?.find((q: any) => q.mappingField === retryKey)
        const matchedOpt = retryQuestion?.options?.find((opt: any) => opt.option_value === retryValue?.option_value || opt.option_label === retryValue?.option_label || (retryValue?.option_desc && opt.option_desc === retryValue?.option_desc))
        patchValuesRetry[retryKey] = matchedOpt?.option_label || retryValue?.option_label
      }
    }
    this.personalDetailsForm.patchValue(patchValuesRetry)
  }

  onInputChange (field: string, value: string, event?: any): any {
    if (event?.selected === false) {
      this.userInputService.deleteValue(field)
    } else {
      this.userInputService.setValue(field, value)
    }
  }

  onMultiSelect (field: string, selectedValues: string[] | string): void {
    this.userInputService.setValue(field, selectedValues)
  }

  clearSelection (field: string): void {
    this.personalDetailsForm.get(field)?.setValue('')
    this.userInputService.deleteValue(field)
  }

  onInputString (field: string, event: FocusEvent): void {
    const inputElement = event.target as HTMLInputElement
    const trimmedValue = inputElement.value.trim()
    inputElement.value = trimmedValue
    this.userInputService.setValue(field, trimmedValue)
    this.personalDetailsForm.get(field)?.setValue(trimmedValue)
  }

  onDateChange (event: any): void {
    const d = moment(event.value).format('DD/MM/YYYY')
    if (!(d.match(/^\d{2}\/\d{2}\/\d{4}$/) && d.includes('/'))) {
      this.userInputService.deleteValue('date_of_birth')
      this.userInputService.deleteValue('date_of_birth_API')
      this.invalidDate = true
    } else {
      const selectedDate = moment(event.value, 'DD/MM/YYYY')
      const yesterdayDate = moment().startOf('day').subtract(1, 'day')
      if (selectedDate.isAfter(yesterdayDate)) {
        this.userInputService.deleteValue('date_of_birth')
        this.userInputService.deleteValue('date_of_birth_API')
        this.futureDate = true
      } else {
        this.invalidDate = false
        this.futureDate = false
        const dateDisplay = selectedDate.format('DD/MM/YYYY')
        const dobAPI = selectedDate.format('YYYY-MM-DD') + 'T00:00:00'
        this.onInputChange('date_of_birth', dateDisplay)
        this.onInputChange('date_of_birth_API', dobAPI)
      }
    }
  }

  phoneNumberValidation (phoneNumber: any): any {
    this.selectedDialCode = phoneNumber
    this.minimumLength = phoneNumber.minLength
    this.maximumLength = phoneNumber.maxLength
    this.phoneNumber('primary_mobile_number')
    this.mobileNumberCount = phoneNumber.minLength === phoneNumber.maxLength
      ? phoneNumber.minLength
      : phoneNumber.minLength + ' - ' + phoneNumber.maxLength
    this.phoneNumberInvalidError = ''
    const key = this.selectedLanguage === 'EN' ? this.selectedLanguage : this.country + '_' + this.selectedLanguage
    this.phoneNumberInvalidError = languageContent[key]?.phoneNumberInvalidError1 + ' ' + this.mobileNumberCount + ' ' + languageContent[key]?.phoneNumberInvalidError2
  }

  phoneNumber (mappingField: any): any {
    if (mappingField === 'primary_mobile_number') {
      const mobNum = this.personalDetailsForm.controls.primary_mobile_number?.value.length
      const isDigit = this.validatorService.isDigit(this.personalDetailsForm.controls.primary_mobile_number?.value)
      if (isDigit) {
        if (mobNum < this.minimumLength || mobNum > this.maximumLength || mobNum === 0) {
          this.personalDetailsForm.controls.primary_mobile_number?.setErrors({ invalidPhoneNumber: true })
        } else {
          this.personalDetailsForm.controls.primary_mobile_number?.setErrors(null)
        }
      } else {
        this.personalDetailsForm.controls.primary_mobile_number?.setErrors({ invalidPhoneNumber: true })
      }
      if (!mobNum) {
        this.personalDetailsForm.controls.primary_mobile_number?.setErrors({ required: true })
      }
      const key = this.selectedLanguage === 'EN' ? this.selectedLanguage : this.country + '_' + this.selectedLanguage
      this.phoneNumberInvalidError = languageContent[key]?.phoneNumberInvalidError1 + ' ' + this.mobileNumberCount + ' ' + languageContent[key]?.phoneNumberInvalidError2
    }
  }

  openLearnMorePopup (): void {
    this.showLearnMorePopup = true
    document.body.classList.add('no-scroll')
  }

  closeLearnMorePopup (): void {
    this.showLearnMorePopup = false
    document.body.classList.remove('no-scroll')
  }

  preventEnter (event: Event): void {
    const keyboardEvent = event as KeyboardEvent
    keyboardEvent.preventDefault()
    keyboardEvent.stopPropagation()
  }

  calculateStudyPlanTimeline (studyPlanDate: string): string {
    const targetDate = moment(studyPlanDate, 'MMM-YYYY')
    if (!targetDate.isValid()) return ''
    const now = moment()
    const diffMonths = targetDate.diff(now, 'months')
    if (diffMonths <= 0) return 'Now'
    if (diffMonths <= 3) return '3 months'
    if (diffMonths <= 6) return '6 months'
    if (diffMonths <= 12) return '12 months'
    return 'More than 12 months'
  }

  nextButton (): void {
    this.submitted = true
    this.phoneNumber('primary_mobile_number')
    if (this.personalDetailsForm.valid) {
      if (this.userInputService.getValue('interestedIDPSerivce')) {
        this.allData = this.userInputService.getAllValues()
        const interestedData = this.allData['interestedIDPSerivce']
        this.interestedIdpServiceGTM = Array.isArray(interestedData)
          ? interestedData.map((item: any) => item.option_desc || item.option_label).filter((val: string) => !!val).join('|')
          : ''
        this.userInputService.setValue('preferredServiceGTM', this.interestedIdpServiceGTM)
      }
      this.gtmImplementation.trackEvents('wir_personal_details', 'next_button', 'next', 'personal_details', 'signed_in_user', 'user_registration')
      if (this.userInputService.getValue('dialCode') === undefined) {
        this.userInputService.setValue('dialCode', this.personalDetailsForm.value.dialCode)
      }
      this.nextClicked.emit()
    } else {
      setTimeout(() => {
        const invalidControl = document.querySelector('form .ng-invalid') as HTMLElement
        if (invalidControl) {
          invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' })
          setTimeout(() => {
            const elementToFocus = invalidControl.querySelector('input, [type="checkbox"], mat-select') || invalidControl
            elementToFocus.classList.add('scroll-field-error');
            (elementToFocus as HTMLElement).focus()
          }, 300)
        }
      }, 50)
    }
  }
  scrollToTop (): void {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
 
  ngOnDestroy (): void {
    clearTimeout(this.scrollTimer)
  }
}
